<template>
  <div id="app">
    <div class="mainContent">
      <Homepage />
    </div>
  </div>
</template>

<script>
import tiltEffect from "./custom";
import Homepage from "../src/pages/Homepage";
import "./stylesheets/main.css";

export default {
  name: "App",
  components: {
    Homepage,
  },
  beforeCreate() {
    document.title = 'Syntax 2021 - Talking Tech for the Future'
  },
  mounted() {
    // Send Analytics
    this.$ga.page('/');
    tiltEffect();
  },
};
</script>

